import { scrollToEl } from './smoothScroller.js'

export const select = () => {

	let els = document.querySelectorAll('[data-placeholder]')

	if (!els.length) return

	els.forEach(el => {

		let $el = jQuery(el)

		$el.select2({
			placeholder: el.dataset.placeholder
		})

		$el.on('change', function () {
			let value = jQuery(this).val()
			if (value) {
				console.log(value)
				let target = document.getElementById(value)
				console.log(target)
				scrollToEl(target)
			}
		})
	})
}

export default () => { }